import * as R from 'ramda';

import { getIn } from 'utils';

import { utils } from '../';

function isFormDisabledSetterHandler({ setIsFormDisabled }) {
  const setter = R.pipe(
    getIn('meta.isDisabled'),
    R.unless(R.isNil, setIsFormDisabled),
  );

  return R.tap(setter);
}

function legalNameEditableSetterHandler({ setLegalNameEditable }) {
  const setter = R.pipe(
    getIn('meta.legalNameEditable'),
    R.unless(R.isNil, setLegalNameEditable),
  );

  return R.tap(setter);
}

function mergeInitialValuesHandler({ setInitialValues, isFormDisabledSetter, legalNameEditableSetter }) {
  return R.pipe(
    isFormDisabledSetter,
    legalNameEditableSetter,
    utils.setDefaultInitialValues,
    setInitialValues,
  );
}

function onSubmitHandler({ updateApplicationFourthStep }) {
  return (values, form) => updateApplicationFourthStep(utils.valuesSubmitPreparation(values), form);
}

export {
  mergeInitialValuesHandler as mergeInitialValues,
  onSubmitHandler as onSubmit,
  isFormDisabledSetterHandler as isFormDisabledSetter,
  legalNameEditableSetterHandler as legalNameEditableSetter,
};
